import { useState } from "react";

import { Button } from "@aircall/ds";
import { useTranslation } from "react-i18next";

import type { BannerProps } from "./AiPromotionalBanner.decl";

import { FeatureBanner } from "@/components/FeatureBanner";
import { useCall } from "@/hooks/useCall/useCall";
import { useShouldDisplayPromotionalBanner } from "@/hooks/useShouldDisplayPromotionalBanner/useShouldDisplayPromotionalBanner";
import { useTrackBanner } from "@/hooks/useTrackBanner/useTrackBanner";
import { ButtonLink } from "../ButtonLink/ButtonLink";

export function AiPromotionalBanner({ direction, alignItems }: BannerProps) {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);
  const { handleClick } = useTrackBanner();
  const { call } = useCall();

  const shouldBeNotifiedForAiPackage = useShouldDisplayPromotionalBanner();

  if (
    !isVisible ||
    !shouldBeNotifiedForAiPackage ||
    call?.type === "voicemail"
  ) {
    return null;
  }

  const hideOnClick = () => {
    setIsVisible(false);
  };

  return (
    <FeatureBanner
      fluid
      content={t("ai.banner.content")}
      direction={direction}
      alignItems={alignItems}
    >
      <div className="flex items-center gap-4">
        <Button variant="link" size="sm" onClick={hideOnClick}>
          {t("close")}
        </Button>
        <ButtonLink
          onClick={handleClick}
          href={t("ai.banner.href")}
          target="_blank"
          size="sm"
        >
          {t("ai.banner.button")}
        </ButtonLink>
      </div>
    </FeatureBanner>
  );
}
